import {Tabs } from "antd";
import ServiceTitanDetails from "./ServiceTitanBusinessUnits/ServiceTitanDetails";
import HouseCallProDetails from "./ServiceTitanBusinessUnits/HouseCallProDetails";
import JobsMappingUpload from "./ServiceTitanBusinessUnits/UploadJobMappings";
import ThirdPartyInfo from "./ThirdPartyInfo";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";

const ServiceTitanBusinessUnits = () => {
	const { organizationData } = useSelector((state) => state?.organization);
	const isHCP = organizationData?.organization_provider === 'HCP';
	const [searchParams] = useSearchParams();
	const tabFromUrl = searchParams.get("section");
	const [activeKey, setActiveKey] = useState(tabFromUrl || "1");

	const childComponents = [
		{
			label: `Details`,
			key: "1",
			children: isHCP ? <HouseCallProDetails /> : <ServiceTitanDetails />,
		},
		{
			label: `Upload Job Mappings`,
			key: "2",
			children: <JobsMappingUpload />,
		},
		{
			label: "API Integration Keys",
			key: "3",
			children: <ThirdPartyInfo />,
		},
	];

	return (
		<Tabs
			activeKey={activeKey}
			defaultActiveKey={activeKey}
			onChange={(key) => {
				setActiveKey(key);
			}}
			tabPosition={"left"}
			style={{
				height: "auto",
			}}
			items={childComponents.map((item) => {
				return {
					label: item.label,
					key: item.key,
					children: item.children,
				};
			})}
		/>
	);
};

export default ServiceTitanBusinessUnits;
